import * as React from 'react';
export const LayoutContext = /*#__PURE__*/React.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/layout/context.js
// module id = 1040
// module chunks = 0